import { useEffect } from "react";
import { useParams } from "react-router";
import { rememberConnectCode } from "@/utils/connect-code-stash";

/**
 * Remembers the code of a `/connect/:code` URL in every auth state, so a visitor who signs up and
 * founds an organisation first still reaches the connect page afterwards. Renders nothing.
 */
export function RememberConnectCode() {
	/** Hooks */
	const { code } = useParams<{ code: string }>();

	/** Effects */
	useEffect(() => {
		if (code) rememberConnectCode(code);
	}, [code]);

	/** Render */
	return null;
}
